'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M256 320c0-141.385 114.615-256 256-256s256 114.615 256 256c0 141.385-114.615 256-256 256s-256-114.615-256-256zM768 640h-512c-141.384 0-256 114.618-256 256v64h1024v-64c0-141.382-114.616-256-256-256z' })
    ));
};